// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { tabsStyles } from "@guestsupply/App/Widgets/XTabs/XTabs";
import { hideElementOnPrint } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

tabsStyles.tabsContainer = {
    cssOverrides: {
        wrapper: css`
            padding: 0;
        `,
    },
};

tabsStyles.gridItem = {
    css: css`
        flex-wrap: wrap;
        width: 100%;
        ${({ isLoading }: any) => (isLoading ? "display: none;" : "")}
    `,
};

tabsStyles.container = {
    css: css`
        margin: 25px 0;
        ${hideElementOnPrint}
    `,
};

tabsStyles.productCategoriesSelect = {
    css: css`
        margin-bottom: 12px;
    `,
};
